import React, { Component } from "react";
import PropTypes from "prop-types";
import MobileDetect from "mobile-detect";
import _ from "lodash";
import { BackgroundImage, Parawow, Image } from "../components";

const feather2 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-2.png`;
const feather4 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-4.png`;
const feather5 = `${process.env.PUBLIC_URL}/assets/images/event-page/event-5.png`;
const layoutfeather1 = `${process.env.PUBLIC_URL}/assets/images/event-page/layout-feather1.png`;
const layoutleaf1 = `${process.env.PUBLIC_URL}/assets/images/event-page/layout-leaf1.png`;

const md = new MobileDetect(window.navigator.userAgent);

export default class LayoutPageEvents extends Component {
  static propTypes = {
    media: PropTypes.string,
    pageName: PropTypes.string,
    type: PropTypes.string,
    bgColor: PropTypes.string,
    imageMobile: PropTypes.string,
  };
  static defaultProps = {
    media: "eU19RyPikwQ",
    pageName: "",
    type: "",
    bgColor: "#40066c",
    imageMobile: "",
  };

  getMediaHeaderDesktop = () => {
    const { image, imageMobile, media } = this.props;

    if (md.mobile()) {
      return <BackgroundImage image={imageMobile || image} />;
    } else if (image) {
      return <BackgroundImage image={image} />;
    } else {
      return (
        <iframe
          title="ourshowtiffany"
          src={`https://www.youtube.com/embed/${media}?autoplay=1&loop=1&rel=0&showinfo=0&controls=0&mute=1&color=white&iv_load_policy=3&playlist=${media}`}
          allowFullScreen
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
        />
      );
    }
  };

  render() {
    const { pageName, type, bgColor, image, imageMobile } = this.props;

    return (
      <div
        className={`layout-page-component ${
          !_.isEmpty(md.mobile()) ? "hide-feather" : ""
        }`}
      >
        {type !== "primary" && (
          <div>
            <Parawow
              scrollRange={[0, 600]}
              style={[{ top: "250px" }, { top: "0px" }]}
            >
              {(style) => (
                <Image
                  className="feather2"
                  src={feather2}
                  alt=""
                  style={style}
                />
              )}
            </Parawow>
            <Parawow
              scrollRange={[0, 800]}
              style={[{ top: "290px" }, { top: "0px" }]}
            >
              {(style) => (
                <Image
                  className="feather5"
                  src={feather5}
                  alt=""
                  style={style}
                />
              )}
            </Parawow>
            <Parawow
              scrollRange={[0, 1000]}
              style={[{ top: "780px" }, { top: "1500px" }]}
            >
              {(style) => (
                <Image
                  className="feather7"
                  src={layoutleaf1}
                  alt=""
                  style={style}
                />
              )}
            </Parawow>
            <div>
              {/* <Image className="feather2" src={feather2} alt="" /> */}
              <Image className="feather4" src={feather4} alt="" />
              {/* <Image className="feather5" src={feather5} alt="" /> */}
              <Image className="feather6" src={layoutfeather1} alt="" />
              {/* <Image className="feather7" src={layoutleaf1} alt="" /> */}
            </div>
          </div>
        )}

        <div className="container-media">
          <h1 className="page-name">{pageName}</h1>
          <div className="container-video">
            <div
              className="d-none d-md-block desktop"
              style={{ width: "100%", height: "100%" }}
            >
              {this.getMediaHeaderDesktop()}
            </div>
            <div
              className="d-md-none mobile"
              style={{ width: "100%", height: "100%" }}
            >
              <BackgroundImage image={imageMobile || image} />
            </div>
          </div>
        </div>
        {type === "primary" && (
          <div
            className="container-highlight-first"
            style={{ backgroundColor: bgColor }}
          />
        )}
        <div
          className={
            type === "primary"
              ? "container-page-content-primary"
              : "container-page-content-default"
          }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LayoutPage.js